import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './ErrorFallbackStyle.css';

function ErrorFallback({
    error,
    resetErrorBoundary,
    message,
    onRetry,
    secondaryAction,
}) {
    const handleFeedback = () => {
        console.error('User reported error:', error || finalMessage);
        alert('오류 제보 기능은 아직 서버와 연결되어 있지 않습니다.');
    };

    // message prop(라우트에서 전달) > error.userMsg > error.message > 기본 문구
    const finalMessage =
        message || error?.userMsg || error?.message || '알 수 없는 오류가 발생했습니다.';

    const handleRetry = () => {
        if (typeof onRetry === 'function') {
            onRetry();
            return;
        }
        if (typeof resetErrorBoundary === 'function') {
            resetErrorBoundary();
        } else {
            // 바운더리 없이 /error 라우트로 직접 들어온 경우: 홈으로 이동(또는 새로고침)
            if (window?.history?.length > 1) {
                window.history.back();
            } else {
                window.location.href = '/';
            }
        }
    };

    /* ---------- 모달 JSX ---------- */
    const modalJSX = (
        <div role="alert" className="error-backdrop">
            <div className="error-modal">
                <div className="modal-content">
                    <div className="modal-icon"></div>
                    <p className="modal-message">{finalMessage}</p>
                </div>
                <div className="modal-buttons">
                    <button className="retry-btn" onClick={handleRetry}>
                        다시 시도
                    </button>
                    {secondaryAction && (
                        <button
                            className="secondary-btn"
                            onClick={secondaryAction.onClick}
                        >
                            {secondaryAction.label}
                        </button>
                    )}
                    <button className="report-btn" onClick={handleFeedback}>
                        오류 제보
                    </button>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalJSX, document.body);
}

ErrorFallback.propTypes = {
    error: PropTypes.object,
    resetErrorBoundary: PropTypes.func,
    message: PropTypes.string,
    onRetry: PropTypes.func,
    secondaryAction: PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    }),
};

export default ErrorFallback;
